const myProject = require('./_data/myProject');
const envSettings = myProject[myProject.environment];

/**
 * Gets a reCAPTCHA v3 token if the library is available.
 * Returns a Promise that resolves with the token string or null.
 */
module.exports = function getRecaptchaToken() {
    return new Promise(function(resolve) {
        if (typeof grecaptcha !== 'undefined') {
            grecaptcha.ready(function() {
                grecaptcha.execute(envSettings.recaptchaSiteKey, { action: 'submit' })
                    .then(resolve)
                    .catch(function() { resolve(null); });
            });
        } else {
            resolve(null);
        }
    });
};
